<template>
  <PopModal ref="modal" :is-large="true" :title="$t(title)">
    <div class="poiCode">
      <div
          id="qrcode1"
          class="qrcode d-flex justify-center mt-2 mb-2"
      />
    </div>
    <van-empty
      v-if="!channel_list || channel_list.length === 0"
      :description="$t('暂无可用充值方式')"
    />
    <div v-else id="offline_wallet_recharge_modal_body" class="container pa-3">
      <form>
        <div class="modal-body gry-bg px-3 pt-3 mx-auto">
          <div class="align-items-center gutters-5 row">
            <div
              v-for="(channel, index) in channel_list"
              :key="index"
              class="col-6 col-md-4"
              @click="clickChannel(index)"
            >
              <label class="aiz-megabox d-block mb-3">
                <input
                  v-model="channelIndex"
                  :value="index"
                  name="payment_option"
                  type="radio"
                />
                <span class="d-block p-3 aiz-megabox-elem">
                  <span class="d-block text-center">
                    <span class="d-block fw-600 fs-15">{{ channel.name }}</span>
                  </span>
                </span>
              </label>
            </div>
          </div>

          <!--          <div id="manual_payment_data">-->
          <!--            <div class="card mb-3 p-3">-->
          <!--              <div id="manual_payment_description">-->
          <!--                <div>-->
          <!--                  <p>-->
          <!--                    <font style="vertical-align: inherit;"-->
          <!--                      ><font style="vertical-align: inherit;"-->
          <!--                        ><font style="vertical-align: inherit;"-->
          <!--                          ><font style="vertical-align: inherit;"-->
          <!--                            ><font style="vertical-align: inherit;"-->
          <!--                              ><font style="vertical-align: inherit;"-->
          <!--                                >3K3YUbRzFWZGnQxGhwDW1royUKoiqC8k8e</font-->
          <!--                              ></font-->
          <!--                            ></font-->
          <!--                          ></font-->
          <!--                        ></font-->
          <!--                      ></font-->
          <!--                    >-->
          <!--                  </p>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <textarea-->
          <!--                id="manual_payment_description_text"-->
          <!--                class="form-control"-->
          <!--                readonly=""-->
          <!--                style="display: none"-->
          <!--                type="text"-->
          <!--              >-->
          <!--3K3YUbRzFWZGnQxGhwDW1royUKoiqC8k8e</textarea-->
          <!--              >-->
          <!--            </div>-->
          <!--            <div class="card mb-3 p-3">-->
          <!--              <button-->
          <!--                class="btn btn-sm btn-primary transition-3d-hover mr-1"-->
          <!--                onclick="copyUsdtUrl()"-->
          <!--                type="button"-->
          <!--              >-->
          <!--                Copy-->
          <!--              </button>-->
          <!--            </div>-->

          <!--            <div class="card mb-3 p-3">-->
          <!--              <input name="type" type="hidden" value="1" />-->

          <!--              <div class="row mt-3">-->
          <!--                <div class="col-md-3">-->
          <!--                  <label>Amount <span class="text-danger">*</span></label>-->
          <!--                </div>-->
          <!--                <div class="col-md-9">-->
          <!--                  <input-->
          <!--                    class="form-control mb-3"-->
          <!--                    lang="en"-->
          <!--                    min="0"-->
          <!--                    name="amount"-->
          <!--                    placeholder="Amount"-->
          <!--                    required=""-->
          <!--                    step="0.01"-->
          <!--                    type="number"-->
          <!--                  />-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="row">-->
          <!--                <div class="col-md-3">-->
          <!--                  <label-->
          <!--                    >Transaction ID <span class="text-danger">*</span></label-->
          <!--                  >-->
          <!--                </div>-->
          <!--                <div class="col-md-9">-->
          <!--                  <input-->
          <!--                    class="form-control mb-3"-->
          <!--                    name="trx_id"-->
          <!--                    placeholder="Transaction ID"-->
          <!--                    required=""-->
          <!--                    type="text"-->
          <!--                  />-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="form-group row">-->
          <!--                <label class="col-md-3 col-form-label">Photo</label>-->
          <!--                <div class="col-md-9">-->
          <!--                  <div-->
          <!--                    class="input-group"-->
          <!--                    data-toggle="aizuploader"-->
          <!--                    data-type="image"-->
          <!--                  >-->
          <!--                    <div class="input-group-prepend">-->
          <!--                      <div-->
          <!--                        class="input-group-text bg-soft-secondary font-weight-medium"-->
          <!--                      >-->
          <!--                        Browse-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                    <div class="form-control file-amount">Choose image</div>-->
          <!--                    <input class="selected-files" name="photo" type="hidden" />-->
          <!--                  </div>-->
          <!--                  <div class="file-preview box sm"></div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->

          <!--            <div class="form-group text-right">-->
          <!--              <button-->
          <!--                class="btn btn-sm btn-primary transition-3d-hover mr-1"-->
          <!--                type="submit"-->
          <!--              >-->
          <!--                Confirm-->
          <!--              </button>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </form>

      <template v-if="channel">
        <template v-if="channel.merchantCode === 'SYSTEMPAY'">
          <template v-if="!channel.isBank">
            <template>
              <div class="title mt-4">{{ $t("钱包收款码") }}</div>
              <div class="poiCode">
                <div
                  id="qrcode1"
                  class="qrcode d-flex justify-center mt-2 mb-2"
                />
              </div>
              <van-field :label="$t('钱包地址')">
                <template #input>
                  <div class="">
                    <div class="text line2">{{ channel.channelCode }}</div>
                    <div>
                      <van-button
                        class=""
                        color="#f7ce29"
                        size="mini"
                        type="primary"
                        @click="copy_txt(channel.channelCode)"
                      >
                        <span class="text-000 ft-12">{{ $t("复制") }}</span>
                      </van-button>
                    </div>
                  </div>
                </template>
              </van-field>
            </template>
          </template>
          <template v-else>
            <van-field
              v-if="channel.bankName"
              :label="$t('收款银行')"
              class="cell-item mt-4"
            >
              <template #input>
                <div class="wallet-info d-flex flex-full justify-between">
                  <span class="text">{{ channel.bankName }}</span>
                  <van-button
                    class="ml-2"
                    color="#f7ce29"
                    size="mini"
                    type="primary"
                    @click="copy_txt(channel.bankName)"
                  >
                    <span class="text-000 ft-12">{{ $t("复制") }}</span>
                  </van-button>
                </div>
              </template>
            </van-field>
            <van-field
              v-if="channel.bankUsername"
              :label="$t('收款人')"
              class="cell-item"
            >
              <template #input>
                <div class="wallet-info d-flex flex-full justify-between">
                  <span class="text">{{ channel.bankUsername }}</span>
                  <van-button
                    class="ml-2"
                    color="#f7ce29"
                    size="mini"
                    type="primary"
                    @click="copy_txt(channel.bankUsername)"
                  >
                    <span class="text-000 ft-12">{{ $t("复制") }}</span>
                  </van-button>
                </div>
              </template>
            </van-field>
            <van-field
              v-if="channel.bankAccount"
              :label="$t('收款账号')"
              class="cell-item"
            >
              <template #input>
                <div class="wallet-info d-flex flex-full justify-between">
                  <span class="text">{{ channel.bankAccount }}</span>
                  <van-button
                    class="ml-2"
                    color="#f7ce29"
                    size="mini"
                    type="primary"
                    @click="copy_txt(channel.bankAccount)"
                  >
                    <span class="text-000 ft-12">{{ $t("复制") }}</span>
                  </van-button>
                </div>
              </template>
            </van-field>
          </template>
        </template>
        <template v-else-if="channel.merchantCode === 'TRONPAY'">
          <template v-if="paramMapAll['RECHARGE_QRCODE_CLOSE'] !== '1'">
            <div class="title mt-4">{{ $t("钱包收款码") }}</div>
            <div class="poiCode">
              <div
                id="qrcode2"
                class="qrcode d-flex justify-center mt-2 mb-2"
              ></div>
            </div>
          </template>
          <van-field :label="$t('钱包地址')">
            <template #input>
              <div class="">
                <div class="text line2">{{ address }}</div>
                <div>
                  <van-button
                    class=""
                    color="#f7ce29"
                    size="mini"
                    type="primary"
                    @click="copy_txt(address)"
                  >
                    <span class="text-000 ft-12">{{ $t("复制") }}</span>
                  </van-button>
                </div>
              </div>
            </template>
          </van-field>
        </template>

        <van-field :key="'金额限制'" :label="$t('金额限制')" class="mt-2">
          <template #input>
            <div class="wallet-info d-flex flex-full">
              <span class="text"
                >{{ formatMoney(channel.minAmount) }} ~
                {{ formatMoney(channel.maxAmount) }}</span
              >
            </div>
          </template>
        </van-field>
        <template v-if="channel.merchantCode !== 'TRONPAY'">
          <van-field
            :key="'formObj.amount'"
            v-model.trim="formObj.amount"
            type="number"
            :label="$t('充值金额')"
            :placeholder="$t('请输入充值金额')"
          />

          <van-field :key="'money_list'" class="cell-item" label=""  v-if="paramMapAll['SYSTEM_VERSION'] !== 'D06'" >
            <template #input>
              <span v-if="channel.exchangeRate !== 1">
            ≈ {{ formatMoney(formObj.amount / channel.exchangeRate) }}
            </span>
              <div class="pa-3 d-flex flex-full flex-wrap">
                <van-button
                  v-for="(item, index) in money_list"
                  :key="index"
                  plain
                  size="small"
                  style="margin: 10px 10px 10px 0px;border-radius: 5px; background-color: #efefef;border: 1px solid grey"
                  @click="chooseMoney(item)"
                >
                  {{ formatMoney(item) }}
                </van-button>
              </div>

            </template>
          </van-field>
        </template>

        <template v-if="channel.merchantCode === 'SYSTEMPAY'">
          <template v-if="channel.inputBankName">
            <van-field
              v-model.trim="formObj.bankName"
              :label="$t('付款银行')"
              :placeholder="$t('请输入付款银行')"
            />
            <van-field v-if="channel.inputBankUsername"
              v-model.trim="formObj.bankUsername"
              :label="$t('付款人')"
              :placeholder="$t('请输入付款人')"
            />
            <van-field
                v-if="channel.inputBankAccount"
                v-model.trim="formObj.bankAccount"
              :label="$t('付款账号')"
              :placeholder="$t('请输入付款账号')"
            />
          </template>
          <van-field v-if="channel.inputPic" :label="$t('付款凭证')">
            <template #input>
              <van-uploader :after-read="afterPicRead">
                <img
                  v-if="formObj.pic"
                  :src="getFileViewUrl(formObj.pic)"
                  width="130"
                />
              </van-uploader>
            </template>
          </van-field>
        </template>
        <div class="tips text-red2 mb-2">{{ channel.explanation }}</div>
        <div style="margin: 16px;">
          <van-button
            :loading="loading"
            :loading-text="$t('submitting')"
            block
            round
            small
            type="primary"
            @click="confirm"
          >
            {{ $t("Confirm") }}
          </van-button>
        </div>
      </template>
    </div>
  </PopModal>
</template>
<script>
import PopModal from "@/components/PopModal.vue";
import { createOrder, getChannelList } from "@/api/user.recharge";
import { getUserTronInfo } from "@/api/user.tron";

export default {
  components: {
    PopModal
  },
  computed: {
    ...Vuex.mapGetters(["paramMapAll"])
  },
  props: {
    title: String,
    offline: Boolean
  },
  data() {
    return {
      address: null,
      channel_list: [],
      channelIndex: null,
      channel: null,

      loading: false,
      money_list: [],
      formObj: { amount: null, pic: null },
      token: null
    };
  },
  created() {
    this.getUserTronInfo();
    this.getChannelList();
    this.money_list =
        this.paramMapAll["RECHARGE_MONEYS"] &&
        this.paramMapAll["RECHARGE_MONEYS"].split(",");
  },
  methods: {
    show() {
      this.$refs.modal.show();
      this.getToken();
    },
    async getToken() {
      this.token = (await this.$store.dispatch("common/getToken")).data;
    },
    getUserTronInfo() {
      getUserTronInfo().then(res => {
        const data = res.data || {};
        this.address = data["recharge_basic"];
      });
    },
    getChannelList() {
      getChannelList().then(res => {
        if (res.data && res.data.length > 0) {
          this.channel_list = res.data
            .filter(o =>
              this.offline
                ? o.merchantCode === "SYSTEMPAY"
                : o.merchantCode !== "SYSTEMPAY"
            )
            .map(o => {
              if (o.defaultAmount && o.defaultAmount > 0) {
                o.amount = o.defaultAmount;
              }
              o.isBank = o.payType.includes("BANK");
              return o;
            });
          const channelIndex = this.channel_list.findIndex(
            o => !o.showDisabled
          );
          if (channelIndex < 0) return;
          this.clickChannel(channelIndex);
        }
      });
    },
    clickChannel(channelIndex) {
      this.channelIndex = channelIndex;
      const channel = (this.channel = this.channel_list[channelIndex]);
      if (
        channel.payType.includes("USDT_") ||
        channel.payType.includes("USDT-")
      ) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.qrcode(channel.channelCode, "qrcode1");
          });
        }, 200);
      } else if (channel.merchantCode === "TRONPAY") {
        setTimeout(() => {
          this.$nextTick(() => {
            this.qrcode(this.address, "qrcode2");
          });
        }, 500);
      }
    },
    qrcode(url, ele) {
      if (url) {
        this.$nextTick(() => {
          // todo
          new QRCode(ele, {
            width: 160, // 设置宽度
            height: 160, // 设置高度
            text: url
          });
        })
      }
    },
    chooseMoney(money) {
      this.formObj.amount = money;
    },
    afterPicRead(file) {
      // 此时可以自行将文件上传至服务器
      let formdata = new FormData();
      formdata.append("file", file.file);
      formdata.append("module", "front");
      this.$store.dispatch("common/upload", formdata).then(res => {
        this.formObj.pic = res[0];
      });
    },
    confirm() {
      if (!this.formObj.amount) {
        this.$toast.fail(this.$t("请输入充值金额"));
        return;
      }
      if (
        this.formObj.amount < this.channel.minAmount ||
        this.formObj.amount > this.channel.maxAmount
      ) {
        this.$toast.fail(
          this.$t("Recharge_Money_Limit", {
            min: this.channel.minAmount,
            max: this.channel.maxAmount
          })
        );
        return;
      }
      if (this.channel.merchantCode === "SYSTEMPAY") {
        if (this.channel.isBank) {
          if (this.channel.inputBankName && !this.formObj.bankName) {
            this.$toast.fail(this.$t("请输入付款银行"));
            return;
          }
          if (this.channel.inputBankUsername && !this.formObj.bankUsername) {
            this.$toast.fail(this.$t("请输入付款人"));
            return;
          }
          if (this.channel.inputBankAccount && !this.formObj.bankAccount) {
            this.$toast.fail(this.$t("请输入付款账号"));
            return;
          }
        }
        if (this.channel.inputPic && !!this.formObj.pic) {
          this.$toast.fail(this.$t("请上传付款凭证"));
          return;
        }
        this.loading = true;
        this.formObj.payType = this.channel.payType;
        this.formObj["X-IDEMPOTENT-TOKEN"] = this.token;
        this.formObj.merchantCode = this.channel.merchantCode;
        const amount = this.formObj.amount / (this.channel.exchangeRate || 1)
        createOrder({...this.formObj,amount})
          .then(() => {
            this.$toast.success(this.$t("Commit_Success"));
            this.$router.back();
          })
          .finally(async () => {
            this.loading = false;
            this.token = (await this.$store.dispatch("common/getToken")).data;
            if (this.channel.url) {
              window.open(this.channel.url,"_blank")
            }
          });
      } else {
        if (this.timeout > 0) return;
        this.countDownPay();
        let merchantCode = this.channel.merchantCode;
        let merUrl = merchantCode.toLowerCase();
        if (merchantCode.indexOf("_") >= 0) {
          let merArr = merchantCode.split("_");
          merUrl = merArr[0].toLowerCase() + "/" + merchantCode;
        }
        window.open(
          `${this.paramMapAll["PAY_URL"]}pay/${merUrl}/unifiedOrder?amount=${this.formObj.amount}&payType=${this.channel.payType}&returnUrl=${location.href}&userId=${this.userInfo.id}&payChannelId=${this.channel.id}`,
          "_blank"
        );
      }
    },
    countDownPay() {
      this.loading = true;
      this.timeout = 5;
      setInterval(() => {
        this.timeout--;
        if (this.timeout <= 0) {
          clearInterval();
          this.loading = false;
        }
      }, 1000);
    }
  },
};
</script>
